import { TFieldDataConfiguration, TIndexState, TUpsertISRProjectDataModelsInput } from "../model";

type UseFieldDataConfigurationUpdaterProps = {
  setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
}

const useFieldDataConfigurationUpdater = ({setUserProjectDataModels}: UseFieldDataConfigurationUpdaterProps) => {
  
    const updateFieldConfiguration = ( indexInfo: TIndexState, updatedConfig: TFieldDataConfiguration, belongsToDataModel: boolean) => {
      setUserProjectDataModels((prevDataModels) => {
        const newDataModels = { ...prevDataModels };
        if (belongsToDataModel) {
          // Update in the dataModels
          const dataModelToUpdate = newDataModels.project.dataModels[indexInfo.dataModelIndex ?? -1];
          if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.fields[indexInfo.fieldIndex ?? -1] && dataModelToUpdate.data.fields[indexInfo.fieldIndex ?? -1].dataConfiguration) {
            dataModelToUpdate.data.fields[indexInfo.fieldIndex ?? -1].dataConfiguration = {
              ...dataModelToUpdate.data.fields[indexInfo.fieldIndex ?? -1].dataConfiguration,
              ...updatedConfig,
            };
          }
        } else {
          // Update in the fields array
          const fieldToUpdate = newDataModels.project.fields[indexInfo.fieldOutsideDataModelIndex ?? -1];
          if (fieldToUpdate && fieldToUpdate.data && fieldToUpdate.data.dataConfiguration) {
            fieldToUpdate.data.dataConfiguration = {
              ...fieldToUpdate.data.dataConfiguration,
              ...updatedConfig,
            };
          }
        }
  
        return newDataModels;
      });
    };
  
    return { updateFieldConfiguration };
  };
  
export default useFieldDataConfigurationUpdater;